export const locationData = {
  georgetown: 'Medstar-Georgetown',
  rutgers: 'Rutgers Cancer Institute of New Jersey (CINJ) / RWJ Barnabus Health'
}
